/**
 * Production Tool Visibility
 * 
 * Controls which tools are visible in the UI (search, browse, command palette).
 * Hidden tools remain registered and functional — they still work in existing 
 * pipelines and can be used programmatically. This only affects discoverability.
 * 
 * Toggle PRODUCTION_MODE to false to show all tools during development.
 */

export const PRODUCTION_MODE = true;

/** Tool IDs explicitly hidden in production. */
const HIDDEN_TOOL_IDS = new Set<string>([
  'editor-visualizer',
]);

/** Tool types entirely hidden in production. */
const HIDDEN_TOOL_TYPES = new Set<string>([
  'generator',
]);

/**
 * Returns true if the tool should be visible in the UI.
 * When PRODUCTION_MODE is false, all tools are visible.
 */
export function isToolVisible(tool: { id: string; type: string }): boolean {
  if (!PRODUCTION_MODE) return true;
  if (HIDDEN_TOOL_TYPES.has(tool.type)) return false;
  if (HIDDEN_TOOL_IDS.has(tool.id)) return false;
  return true;
}
